import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../supabase';

export default function Registration() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isAdult, setIsAdult] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  //const registrationOnClick = (e) => {

  const handleSubmit = async(e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!firstName || !lastName || !email || !phone || !password || !confirmPassword) {
      setError('Per favore, compila tutti i campi.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Inserisci un indirizzo email valido.');
      return;
    }

    if (!isAdult) {
      setError('Devi confermare di avere almeno 18 anni.');
      return;
    }
    // make sure passwords match
    if (password !== confirmPassword) {
      setError('Le password non coincidono.');
      return;
    }

    const redirectTo = `${window.location.origin}/auth/callback`;

    try {
      const { data, error: signupError } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: redirectTo,
          data: {
            firstName,
            lastName,
            phone: phone ?? null,
          },
        },
      });

      if (signupError) {
        setError(signupError.message || 'Errore durante la registrazione.');
        return;
      }

      // We do not perform a client-side insert here because Row-Level Security
      // disallows client inserts into `users`. Prefer creating the profile via
      // a DB trigger on `auth.users` (recommended) or doing the insert on the server
      // using the service_role key.

      // Optionally: include an `auth_id` uuid column if you want to store the
      // Supabase auth user id alongside your numeric PK. The trigger below can
      // populate that column automatically.


      const userData = { nome: firstName, cognome: lastName, email, telefono: phone, loyalty_points: 0 };

      if (data?.session) {
        login(userData);
        alert('Registrazione completata!');
        navigate('/profile');
        return;
      }

      const confirmationMessage = 'Registrazione completata. Controlla la tua email per confermare l’account.';
      setMessage(confirmationMessage);
      navigate('/login', { state: { message: confirmationMessage } });
    } catch (err) {
      setError(err.message || 'Errore durante la registrazione.');
    }
  };

        return(
    <div className = "form-container" >
      <h2 className="yellow title">Registrati</h2>
      <form onSubmit={handleSubmit}>
        <label>Nome:</label>
        <input
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />
        <label>Cognome:</label>
        <input
          type="text"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label>Telefono:</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <label>Conferma Password:</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <div className="checkbox-row">
          <input
            type="checkbox"
            checked={isAdult}
            onChange={(e) => setIsAdult(e.target.checked)}
          />
          <span>Confermo di avere almeno 18 anni</span>
        </div>

        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
        <button type="submit">Registrati</button>
      </form>
      <p>
        Hai già un account?{' '}
        <Link to="/login" className="link">
          Accedi
        </Link>
      </p>
    </div >
  );
}